export default {
  methods: {
    validateAttachment(value, field) {
      if (!value || !value.length) {
        return field.required ? ["Attachment required"] : [];
      }

      // sizes are in 100 kb | 0.1 mb.
      const size = (value.length - 814) / 1.37 / 100000;
      const limit = 4;
      // compare to size limit of 11mb (advertised as 10mb)
      if (size > limit * 10) {
        return [
          `Attachment is over ${limit}mb size limit (${Math.round(size) /
            10}mb)`
        ];
      }
      return [];
    }
  }
};
